export enum ChartType {
  AREA = "area",
  BAR = "bar",
  MAP_BUBBLE = "mapbubble",
  SPILINE = "spline",
  COLUMN = "column"
}

export enum AxisType {
  X = "xAxis",
  Y = "yAxis",
  DateTime = "datetime", // used for datetime axis
  IsoA3 = "iso-a3" // used for ISO 3166-1 alpha-3 country code
}

export const removeWatermark = {
  credits: {
    enabled: false
  }
};

export enum Period {
  Monthly = "RL28",
  Daily = "RL1",
  Weekly = "RL7",
}

export enum Capability {
  AllUp = "all",
  PersonalApp = "personalTabPersonalBot",
  Tab = "nonPersonalTab",
  MessageExtension = "messageExtension",
  Connectors = "connectors",
  Bot = "nonPersonalBot",
  PersonalTab = "personalTab",
  M365CopilotAgentUsage = "m365CopilotAgentUsage",
}

// Primitive Data Points used by charts
export interface IDateUsageDataPoint {
  date: string;
  usage: number;
}

export interface IDateUsageDataPointString {
  date: string;
  usage: string;
}

export type IMultiLineDateUsageDataPoints = Record<string, IDateUsageDataPoint[]>;

export type IBarChartValues = Record<string, number>;

export interface IIntensityDataPoint {
  median: number;
  percentage: number;
  mau: number;
}

export interface ITrendDataPoint {
  value: number;
  stringValue: string;
  percent: number;
  key: string;
}

// Data for Map Charts, z represents the value
export interface ICountryData {
  name: string;
  z: number;
  latitude?: number;
  longitude?: number;
}

export interface IRangeWiseMultiLineDateUsageDataPoints {
  daily: IMultiLineDateUsageDataPoints;
  weekly: IMultiLineDateUsageDataPoints;
  monthly: IMultiLineDateUsageDataPoints;
}


export interface IPeriodWiseMultiLineDateUsageDataPoints {
  [Period.Daily]?: IMultiLineDateUsageDataPoints;
  [Period.Weekly]?: IMultiLineDateUsageDataPoints;
  [Period.Monthly]?: IMultiLineDateUsageDataPoints;
}

export interface IPeriodWiseSingleLineDateUsageDataPoints {
  [Period.Daily]?: IDateUsageDataPoint[];
  [Period.Weekly]?: IDateUsageDataPoint[];
  [Period.Monthly]?: IDateUsageDataPoint[];
}

export interface IPeriodWiseBarChartValues {
  [Period.Daily]?: IBarChartValues;
  [Period.Weekly]?: IBarChartValues;
  [Period.Monthly]?: IBarChartValues;
}

export interface IPeriodWiseCountryData {
  [Period.Daily]?: ICountryData[];
  [Period.Weekly]?: ICountryData[];
  [Period.Monthly]?: ICountryData[];
}

export interface IPeriodWiseTrendDataPoints {
  [Period.Daily]?: ITrendDataPoint[];
  [Period.Weekly]?: ITrendDataPoint[];
  [Period.Monthly]?: ITrendDataPoint[];
}


export interface IPeriodWiseCapabilityMultiLineDateUsageDataPoints {
  [Capability.AllUp]?: IPeriodWiseMultiLineDateUsageDataPoints;
  [Capability.PersonalApp]?: IPeriodWiseMultiLineDateUsageDataPoints;
  [Capability.Tab]?: IPeriodWiseMultiLineDateUsageDataPoints;
  [Capability.MessageExtension]?: IPeriodWiseMultiLineDateUsageDataPoints;
  [Capability.Connectors]?: IPeriodWiseMultiLineDateUsageDataPoints;
  [Capability.PersonalTab]?: IPeriodWiseMultiLineDateUsageDataPoints;
  [Capability.Bot]?: IPeriodWiseMultiLineDateUsageDataPoints;
  [Capability.M365CopilotAgentUsage]?: IPeriodWiseMultiLineDateUsageDataPoints;
}